import LoadIndicator from 'devextreme-react/load-indicator';
import './EditorCollaborationReload.css';

export interface EditorCollaborationReloadOverlayProps {
  visible: boolean;
  label?: string;
}

export function EditorCollaborationReloadOverlay({
  visible,
  label = 'Loading latest version…'
}: EditorCollaborationReloadOverlayProps) {
  if (!visible) return null;

  return (
    <div className="editor-collaboration-reload" aria-busy="true" aria-live="polite">
      <LoadIndicator visible height={28} width={28} />
      <span className="editor-collaboration-reload__label">{label}</span>
    </div>
  );
}
